<template>
	<div class="col-lg-6 offset-lg-3 col-md-12">
		<div class="card shadow-sm">
			<div class="card-header">
				<div class="d-flex align-items-center justify-content-between">
					<h3 class="df-title">New Fee</h3>
				</div>
			</div>
			<div class="card-body">
				<form class="row" @submit.prevent="addFee">
					<div class="form-group col-12">
						<label>Client</label>
						<select v-model="form.external_client_id" id="client" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('external_client_id') }" required>
							<option :value="null" disabled>Select client</option>
						</select>
						<has-error :form="form" field="external_client_id"></has-error>
					</div>
					<div class="form-group col-12">
						<label>Portfolio</label>
						<select v-model="form.external_portfolio_id" id="portfolio" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('external_portfolio_id') }" :disabled="disabled" required>
							<option :value="null" disabled>Select portfolio</option>
							<option v-for="(portfolio, index) in portfolios" :value="portfolio.id" :key="index">{{ portfolio.name }}</option>
						</select>
						<has-error :form="form" field="external_portfolio_id"></has-error>
					</div>
                    <div class="form-group col-md-6">
						<label>Amount</label>
						<input v-model="form.amount" type="number" step="any" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('amount') }" placeholder="Enter amount">
						<has-error :form="form" field="amount"></has-error>
					</div>
					<div class="form-group col-md-6">
						<label>Currency</label>
						<select v-model="form.currency" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('currency') }" required>
							<option :value="null" disabled>Select currency</option>
							<option v-for="(currency, index) in currencies" :value="currency.value" :key="index">{{ currency.name }}</option>
						</select>
						<has-error :form="form" field="currency"></has-error>
					</div>
                    <div class="form-group col-12">
						<label>Fee Status</label>
						<select v-model="form.status" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('status') }" required>
							<option :value="null" disabled>Select status</option>
							<option v-for="(status, index) in fee_statuses" :value="status.toLowerCase()" :key="index">{{ status }}</option>
						</select>
						<has-error :form="form" field="status"></has-error>
					</div>
                    <div v-show="form.status === 'processed'" class="form-group col-12">
						<label>Date</label>
						<input v-model="form.date" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('date') }" data-toggle="datepicker" name="date" placeholder="Select date">
						<has-error :form="form" field="date"></has-error>
					</div>
					
					<div class="col-12 justify-content-end d-flex">
						<button-component :busy="form.busy" :label="'Create Fee'" :label-loading="'Please wait...'" :button-class="'btn btn-default shadow-sm'"></button-component>
						<button type="button" class="btn btn-primary shadow-sm ml-2" @click="resetForm">Cancel</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			$("[data-toggle='datepicker']").datepicker({
				format: "yyyy-mm-dd",
				autoHide: true
			});

			this.loadOptions().then(() => {
				$("#client").select2({
					data: this.clients,
					placeholder: "Select client",
					width: "100%"
				});
			});
			$("#client").on("select2:select", e => {
				const client = _.find(this.clients, ["id", e.params.data.id]);
				this.loadPortfolio(client.id);
				this.form.external_client_id = client.id;
				this.form.external_custody_account_id =
					client.external_custody_account_id;
			});
			$("#client").on("select2:unselect", e => {
				this.form.external_client_id = this.form.external_custody_account_id = null;
				this.disabled = true;
			});
			$("#portfolio").on("select2:select", e => {
				const portfolio = e.params.data.id;
				this.loadHoldings(portfolio);
				this.form.external_portfolio_id = portfolio;
			});
			$("#portfolio").on("select2:unselect", e => {
				this.form.external_portfolio_id = this.form.security = null;
				this.form.external_portfolio_id = null;
			});
		},
		data() {
			return {
				error: null,
				currencies: this.$store.getters.currencies(),
				fee_statuses: this.$store.getters.fee_statuses,
				clients: null,
				portfolios: null,
				disabled: true,
				form: new Form({
					date: null,
					status: "pending",
					external_portfolio_id: null,
					external_client_id: null,
					currency: null,
					amount: null
				})
			};
		},
		watch: {
			$route: "loadOptions",
			"form.external_portfolio_id": function(id) {
				if (id) {
					const portfolio = _.find(this.portfolios, { id });

					this.form.currency = portfolio.currency;
				}
			}
		},
		methods: {
			getClients() {
				return axios.get("/api/customers");
			},
			loadOptions() {
				return axios.all([this.getClients()]).then(
					axios.spread(clients => {
						let clientsCollection = _.map(
							clients.data.data.customers,
							data => {
								const f = data.first_name;
								const m = data.additional_names || " ";
								const l = data.last_name;
								const client_name = f + " " + m + " " + l;
								return {
									id: data.external_client_id,
									text: client_name,
									external_custody_account_id:
										data.external_custody_account_id
								};
							}
						);
						this.clients = _.sortBy(clientsCollection, ["text"]);
					})
				);
			},
			loadPortfolio(client) {
				this.portfolios = this.form.external_portfolio_id = null;
				this.disabled = true;
				axios
					.get(`/api/customers/${client}`, {
						params: {
							type: "portfolio"
						}
					})
					.then(response => {
						const portfolios = response.data.data.portfolio;
						if (!_.isEmpty(portfolios)) {
							this.portfolios = _.map(portfolios, data => {
								return {
									id: data.external_portfolio_id,
									name: data.portfolio_type.name,
									currency: data.currency
								};
							});
						}
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.disabled = false;
					});
			},
			addFee() {
				this.form.post("/api/fees").then(({ data }) => {
					if (!this.form.any) {
						this.$router.push({
							name: "fees.show",
							params: { id: data.data.fees.id }
						});
					}
				});
			},
			resetForm() {
				this.form.clear();
				this.form.reset();
				$("#client")
					.val(null)
					.trigger("change");
			}
		}
	};
</script>